import { z } from 'zod';

import { TableSidebarRowData } from './useTableSidebarProperties';

const rowIdValueSchema = z.union([z.string(), z.number()]);

export const rowBusinessIdFieldsSchema = z.object({
  actionRowId: rowIdValueSchema.nullish(),
  id: rowIdValueSchema.nullish(),
});

export type RowBusinessIdFields = z.infer<typeof rowBusinessIdFieldsSchema>;

export function parseRowBusinessIdFields(
  row: unknown
): RowBusinessIdFields | undefined {
  const parsed = rowBusinessIdFieldsSchema.safeParse(row);

  return parsed.success ? parsed.data : undefined;
}

export function getRowBusinessId(
  row: TableSidebarRowData['data']
): string | number | undefined {
  const fields = parseRowBusinessIdFields(row);

  if (fields == null) {
    return undefined;
  }

  return fields.actionRowId ?? fields.id ?? undefined;
}
